export default __webpack_public_path__ + "static/media/ToyStory_01.ff146e5d.png";